import { createReducer, on } from '@ngrx/store';
import { GoodModeState, initialGoodModeState } from './goodmode.state';
import { loadingGoodModeActionType } from './goodmode.actions';

export const goodModeReducer = createReducer(
  initialGoodModeState,
  on(loadingGoodModeActionType, (state, { params }): GoodModeState => {
    return { type: params };
  })
);
